import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { Banknote, CreditCard, Receipt, Smartphone, Landmark } from 'lucide-react';
import { PaymentMethod } from '../types/transaction';

interface PaymentMethodSelectorProps {
  selectedMethod: PaymentMethod;
  onSelectMethod: (method: PaymentMethod) => void;
}

const paymentMethods = [
  {
    id: 'cash' as PaymentMethod,
    name: 'نقدي / Espèces',
    icon: Banknote,
    color: 'emerald',
  },
  {
    id: 'card' as PaymentMethod,
    name: 'بطاقة / Carte',
    icon: CreditCard,
    color: 'blue',
  },
  {
    id: 'check' as PaymentMethod,
    name: 'شيك / Chèque',
    icon: Receipt,
    color: 'purple',
  },
  {
    id: 'ccp' as PaymentMethod,
    name: 'CCP',
    icon: Landmark,
    color: 'orange',
  },
  {
    id: 'mobile' as PaymentMethod,
    name: 'محفظة / Mobile',
    icon: Smartphone,
    color: 'teal',
  },
];

export const PaymentMethodSelector = ({
  selectedMethod,
  onSelectMethod,
}: PaymentMethodSelectorProps) => {
  return (
    <div className="flex gap-2 flex-wrap">
      {paymentMethods.map((method) => {
        const Icon = method.icon;
        const isSelected = selectedMethod === method.id;

        return (
          <Button
            key={method.id}
            variant={isSelected ? 'default' : 'outline'}
            size="sm"
            onClick={() => onSelectMethod(method.id)}
            className={cn(
              'h-10 px-3 flex items-center gap-2 transition-all',
              isSelected && 'ring-2 ring-offset-1',
              isSelected && method.color === 'emerald' && 'bg-emerald-500 hover:bg-emerald-600 ring-emerald-500',
              isSelected && method.color === 'blue' && 'bg-blue-500 hover:bg-blue-600 ring-blue-500',
              isSelected && method.color === 'purple' && 'bg-purple-500 hover:bg-purple-600 ring-purple-500',
              isSelected && method.color === 'orange' && 'bg-orange-500 hover:bg-orange-600 ring-orange-500',
              isSelected && method.color === 'teal' && 'bg-teal-500 hover:bg-teal-600 ring-teal-500',
              !isSelected && 'hover:bg-gray-50'
            )}
          >
            <Icon className={cn('w-4 h-4', isSelected ? 'text-white' : 'text-gray-600')} />
            <span className={cn('text-sm font-medium', isSelected ? 'text-white' : 'text-gray-900')}>
              {method.name}
            </span>
          </Button>
        );
      })}
    </div>
  );
};
